const getValueFromPath = function (context, propPath) {
  const props = propPath.split('.')
  if (props.length === 1) { return context[props[0]] }
  if (props.length === 2) { return context[props[0]][props[1]] }
  if (props.length === 3) { return context[props[0]][props[1]][props[2]] }
  if (props.length === 4) { return context[props[0]][props[1]][props[2]][props[3]] }
  if (props.length === 5) { return context[props[0]][props[1]][props[2]][props[3]][props[4]] }
  return null
}

export default function (arrayProp = 'playlists', displayLimitProp = 'displayLimit') {
  return function (e) {
    const arrayObject = getValueFromPath(this, arrayProp)
    const diff = e.target.scrollHeight - (e.target.scrollTop + e.target.offsetHeight)
    if (arrayObject && this[displayLimitProp] < arrayObject.length && diff < 100) {
      this[displayLimitProp] += 30
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/scrollHandler.js